import { render, staticRenderFns } from "./MatchStatsDetail.vue?vue&type=template&id=33abba81&scoped=true"
import script from "./MatchStatsDetail.vue?vue&type=script&lang=js"
export * from "./MatchStatsDetail.vue?vue&type=script&lang=js"
import style0 from "./MatchStatsDetail.vue?vue&type=style&index=0&id=33abba81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33abba81",
  null
  
)

export default component.exports